import { HttpClient } from '@/shared/lib/http-client';

/**
 * Запит на індивідуальне погодження клієнта в СК,
 * коли перевищено ліміт діючих договорів на одного страхувальника.
 *
 * @param {{offerId: string, orderId?: string|null, customer: {identificationCode: string, surname?: string, name?: string, patronymic?: string}}} payload
 */
export const requestClientLimitApproval = async (payload) => {
  const response = await HttpClient.post('company/client-limit-approvals', payload);

  return response.data;
};

export const fetchClientLimitStatus = async ({ offerId, inn }) => {
  const response = await HttpClient.get('company/client-limit-approvals/status', { params: { offerId, inn } });

  return response.data;
};
